import { NonPrimitiveParameter } from './NonPrimitiveParameter';
import { useParameterStore, ValidationStatus } from '@/frontend/store/ParameterStore';
import { CUSTOM_FIELD_TYPES } from '@/types/customFieldTypes';
import { Parameter } from '@/backend/models/parameter';
import { useShallow } from 'zustand/react/shallow';
import { ValidationRunSimplifiedView } from '../validations/ValidationRunSimplifiedView';
import { FileUploader } from '../files/FileUploader';
import { FileSubjectTypes } from '@/types/fileTypes';

export function ParameterRunEditParameterContent(props: { parameter: Parameter }) {
  const { parameter } = props;

  const validations = useParameterStore(useShallow(state => state.getValidationForSubject(parameter.id)));
  const validationStatuses = useParameterStore(useShallow(state => state.getValidationStatusesForSubject(parameter.id)));
  const textFieldTypes = [CUSTOM_FIELD_TYPES.String, CUSTOM_FIELD_TYPES.MultilineText, CUSTOM_FIELD_TYPES.Integer, CUSTOM_FIELD_TYPES.Float, CUSTOM_FIELD_TYPES.Boolean];

  if (!parameter.isPrimitive()) {
    return <div className="d-flex gap-3 align-items-start p-2"><NonPrimitiveParameter parameter={parameter} disabled runView /></div>;
  }

  return (
    <div className="d-flex gap-3 align-items-start p-2">
      { textFieldTypes.includes(parameter.fields[0].fieldType) &&
        <p className='font-monospace small px-2 py-1 mb-0 bg-light border rounded shadow-sm' style={parameter.fields[0].fieldType === CUSTOM_FIELD_TYPES.MultilineText ? { whiteSpace: 'pre-wrap' } : undefined}>{parameter.fields[0].asString()}</p>
      }
      { parameter.fields[0].fieldType === CUSTOM_FIELD_TYPES.File &&
        <FileUploader subjectId={parameter.fields[0].id} subjectType={FileSubjectTypes.CUSTOM_FIELD} hideFilePreview refetchSubject={() => {}} file={parameter.fields[0].file} readOnly />
      }
      { validations.length > 0 && (
        <div className='d-flex flex-column gap-1' style={{minWidth: '200px'}}>
          { !validationStatuses.every(v => v === ValidationStatus.PASSING) && (
            validations.map(validation => (
              <ValidationRunSimplifiedView
                key={validation.id}
                validation={validation}
              />
            ))
          )}
        </div>
      )}
    </div>
  );
}
